// Query Keys für React Query
// Hierarchische Struktur für besseres Cache-Management

export const queryKeys = {
  matches: {
    all: ['matches'],
    lists: () => [...queryKeys.matches.all, 'list'],
    list: (filters) => [...queryKeys.matches.lists(), filters],
    details: () => [...queryKeys.matches.all, 'detail'],
    detail: (id) => [...queryKeys.matches.details(), id],
  },
  frames: {
    all: ['frames'],
    lists: () => [...queryKeys.frames.all, 'list'],
    list: (matchId) => [...queryKeys.frames.lists(), { matchId }],
    details: () => [...queryKeys.frames.all, 'detail'],
    detail: (id) => [...queryKeys.frames.details(), id],
  },
  players: {
    all: ['players'],
    lists: () => [...queryKeys.players.all, 'list'],
    list: (filters) => [...queryKeys.players.lists(), filters],
  },
  gameTypes: {
    all: ['gameTypes'],
    lists: () => [...queryKeys.gameTypes.all, 'list'],
  },
  currentUser: {
    all: ['currentUser'],
    detail: () => [...queryKeys.currentUser.all, 'detail'],
  },
};
